import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-init-error',
  templateUrl: './init-error.component.html',
  styleUrls: ['./init-error.component.scss']
})
export class InitErrorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
